import { Box, Button, Paper, Typography } from '@material-ui/core';
import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router';
import TranslatedText from '../../components/atoms/translated_text';
import VatRateActions from '../../redux/reducers/vat_rate_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import MoneyIcon from '@material-ui/icons/Money';
import { TableColumns, Translations } from './configuration';
import NavigationConfig from '../../navigation/config';
import BaseModal from 'components/molecules/base_modal';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import EditVatRateForm from './components/edit_vat_rate';
import AddVatRateForm from './components/add_vat_rate';
import useQuery from 'custom_hooks/useQuery';

const VatRatesPage = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const country_code = query.get('country_code');
  const vat_rate_type_id = query.get('vat_rate_type_id');
  const valid_from = query.get('valid_from');
  const valid_to = query.get('valid_to');
  const searchParams = {
    ...(country_code && { country_code }),
    ...(vat_rate_type_id && { vat_rate_type_id }),
    ...(valid_from && { valid_from }),
    ...(valid_to && { valid_to }),
  };

  React.useEffect(() => {
    dispatch(VatRateActions.fetchVatRateTypesAction());
    dispatch(
      VatRateActions.fetchVatRateListAction({
        sortField: TableColumns[0].id,
        page: 0,
        pageSize: 25,
        order: 'asc',
        ...searchParams,
      })
    );
  }, [dispatch, country_code, vat_rate_type_id, valid_from, valid_to]);

  return (
    <div>
      <Paper className={clsx(classes.titleLayout)}>
        <Box display="flex" alignItems={'center'}>
          <MoneyIcon style={{ marginRight: '.75rem' }} />
          <Typography component={'span'} style={{ fontSize: '1.5rem' }}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
        <Box display="flex" alignItems={'center'}>
          <AddVatRateButton />
        </Box>
      </Paper>
      <div className={classes.contentContainer}>
        <div className={classes.tableHeader}>
          <Typography component={'p'} variant={'h5'}>
            <TranslatedText
              textMap={Translations.table_title}
              defaultText={Translations.table_title.English}
            />
          </Typography>
        </div>
        <DatatableList />
        <BackToDashboardPage />
      </div>
      <Modals />
    </div>
  );
};

const AddVatRateButton = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const openAdd = () => {
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_ADD_VAT_RATE,
        params: {},
      })
    );
  };

  return (
    <Button className={classes.header_actions} onClick={openAdd}>
      Add VAT Rate
    </Button>
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      style={{ marginTop: '1rem' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

const Modals = () => {
  return (
    <Fragment>
      <BaseModal
        modalID={ModalIDs.MODAL_EDIT_VAT_RATE}
        renderHeader={() => <span>Edit VAT Rate</span>}
        renderContent={(props) => <EditVatRateForm {...props} />}
      />
      <BaseModal
        modalID={ModalIDs.MODAL_ADD_VAT_RATE}
        renderHeader={() => <span>Add VAT Rate</span>}
        renderContent={() => <AddVatRateForm />}
      />
    </Fragment>
  );
};

export default withRouter(VatRatesPage);
